import { apiErrorCodes } from '../../utils/apiHelper'
import { errorCodes, getUserFriendlyErrorMessage } from '../../utils/errormessages'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getErrorMessage = (action) => {
  const errorCode = action.payload.ErrorCode
  if (action.payload.UserFriendlyErrorCode || action.payload.UserFriendlyErrorCode === '') {
    return action.payload.UserFriendlyErrorCode ?
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        getUserFriendlyErrorMessage(action.payload.UserFriendlyErrorCode, null, action.payload.extra)
      : ''
  }
  switch (errorCode) {
    case apiErrorCodes.ID_VERIFICATION_NOT_FOUND:
      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      return getUserFriendlyErrorMessage(errorCodes.NOT_FOUND, null, 'ID verification')
    default:
      return getUserFriendlyErrorMessage(errorCodes.DEFAULT)
  }
}
